import { useEffect, useState } from "react";

import { PLAN_TYPE } from "@/constants";
import PlanModal from "@/containers/PlanModal";
import PublicLayout from "@/containers/PublicLayout";
import { FEATURE } from "@/features";
import { useHasFeature } from "@/hooks/useHasFeature";
import { useOrganization } from "@/hooks/useOrganization";
import { useUser } from "@/hooks/useUser";
import { Episode } from "@/types/Episode";
import { User } from "@/types/User";
import { cx } from "@/utils";
import LoadingNotice from "@/views/ActivationView/partials/LoadingNotice";
import Onboarding from "@/views/ActivationView/partials/Onboarding";
import OnboardingContext from "@/views/ActivationView/partials/OnboardingContext";
import AllEarsTitle from "@components/AllEarsTitle";
import Wizard from "@components/Wizard";

import styles from "@/views/ActivationView/ActivationView.module.css";

const STEPS = [LoadingNotice, Onboarding];

const WelcomeView = () => {
  const canManageAccount = useHasFeature(FEATURE.CAN_MANAGE_ACCOUNT);
  const { data: orgData } = useOrganization();
  const { plan: currentPlan = null } = orgData?.ok ? orgData.data : {};

  const [featuredMention, setFeaturedMention] = useState<Episode | null>(null);
  const { data } = useUser();
  const user = data?.data as User;
  const [missingFeatured, setMissingFeatured] = useState(true);
  const [animated, setAnimated] = useState(0);

  const [isShowingPlans, setIsShowingPlans] = useState<boolean>(false);

  useEffect(() => {
    if (
      animated === 1 &&
      canManageAccount &&
      currentPlan?.type === PLAN_TYPE.FREE
    ) {
      setIsShowingPlans(true);
    }
  }, [currentPlan, canManageAccount, animated]);

  return (
    <>
      <PublicLayout
        className={cx(styles.root, {
          [styles.stepOne]: animated === 1,
          [styles.stepTwo]: animated === 2,
          [styles.stepThree]: animated === 3,
        })}
      >
        <AllEarsTitle title={L.ACTIVATE_TITLE} />
        <div>
          <OnboardingContext.Provider
            value={{
              user: user,
              setUser: () => {},
              missingFeatured,
              setMissingFeatured,
              featuredMention,
              setFeaturedMention,
            }}
          >
            <Wizard steps={STEPS} onStepChange={(num) => setAnimated(num)} />
          </OnboardingContext.Provider>
        </div>
      </PublicLayout>

      <PlanModal
        show={isShowingPlans}
        onHide={() => {
          setIsShowingPlans(false);
        }}
      />
    </>
  );
};
export default WelcomeView;
